var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text mt-5" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(_vm.lblSetting.bmPlanTitle) +
                      ' "' +
                      _vm.params.cmt.subject +
                      '"'
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.bmMeetingPlan
            ? _c(
                "base-control-label-vertical",
                {
                  staticStyle: { "max-width": "50%" },
                  attrs: { required: "", label: _vm.lblSetting.bmPlanLabel }
                },
                [
                  _c("v-select", {
                    staticClass: "mb-1",
                    attrs: {
                      items: _vm.bmMeetingPlan,
                      "v-model": _vm.dtSelectedPlan,
                      value: _vm.dtSelectedPlan,
                      "item-text": "media.name",
                      "item-value": "id",
                      "return-object": "",
                      solo: "",
                      "hide-details": ""
                    },
                    on: { change: _vm.updatePlanSelected }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "mt-3", attrs: { row: "", "align-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs1: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-4",
                      attrs: {
                        disabled: _vm.disabled,
                        flat: "",
                        icon: "",
                        loading: _vm.markerLoading,
                        color: "primary"
                      },
                      on: { click: _vm.deleteMarker }
                    },
                    [_c("v-icon", [_vm._v("undo")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs5: "" } },
                [
                  _c("v-slider", {
                    staticClass: "mr-3",
                    attrs: {
                      min: _vm.minScale,
                      max: _vm.maxScale,
                      "thumb-label": "",
                      color: "primary",
                      step: _vm.scaleMultiplier
                    },
                    model: {
                      value: _vm.scale,
                      callback: function($$v) {
                        _vm.scale = $$v
                      },
                      expression: "scale"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "ml-3", attrs: { column: "" } },
            [
              _c("v-layout", [
                _c("canvas", {
                  attrs: {
                    id: "Canvas",
                    width: _vm.calcWidth,
                    height: _vm.calcHeight
                  }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd367fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd367fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-plan-marker-modal-vertical/template.html
// module id = null
// module chunks = 